import React from 'react'

type Props = { date: string; time: string }

export const TriggerOnPT = ({ date, time }: Props): JSX.Element => (
    <>
        Disparado em {date}, às {time}
    </>
)

export const TriggerOn = ({ date, time }: Props): JSX.Element => (
    <>
        Trigger on {date}, at {time}
    </>
)
